// frontend/smartdocs-admin/src/components/common/SliderInput.tsx
import React from 'react';

interface SliderInputProps {
  id: string;
  label: string;
  description?: string;
  value: number;
  onChange: (value: number) => void;
  min: number;
  max: number;
  step?: number;
  unit?: string;
  disabled?: boolean;
}

const SliderInput: React.FC<SliderInputProps> = ({
  id,
  label,
  description,
  value,
  onChange,
  min,
  max,
  step,
  unit,
  disabled = false
}) => {
  return (
    <div className="py-3">
      <label htmlFor={id} className="block text-sm font-medium text-gray-900 dark:text-gray-100">
        {label}
      </label>
      {description && (
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 mb-2">
          {description}
        </p>
      )}
      <div className="flex items-center space-x-4 mt-2">
        <input
          type="range"
          id={id}
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          className={`w-full h-2 bg-primary-500 rounded-lg appearance-none cursor-pointer dark:bg-gray-700 ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
          disabled={disabled}
        />
        <input
          type="number"
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          min={min}
          max={max}
          step={step}
          className={`w-20 p-2 border border-gray-300 rounded-md text-sm text-gray-900 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100 focus:ring-blue-500 focus:border-blue-500 ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
          disabled={disabled}
        />
        {unit && <span className="text-sm text-gray-700 dark:text-gray-300">{unit}</span>}
      </div>
    </div>
  );
};

export default SliderInput;
